<div
  class="setting-container"
  fxLayout="column"
  fxLayoutAlign="space-around center"
>
  <mat-tab-group [disablePagination]="true" class="tabs" mat-align-tabs="" #Tab>
    <!-- User setting -->
    <mat-tab class="user-setting-tab" label="کاربری">
      <div class="tab-gp">
        <div class="tab-title">
          <jam-icon name="user-square" class="tab-hero" [size]="50"></jam-icon>

          <h2>مشخصات کاربری</h2>
          <small class="tab-description">
            شما در این قسمت می‌توانید مشخصات کاربری خود را بروز و یا تغییر دهید.
          </small>
        </div>

        <div class="group user-info">
          <span class="group-label"> مشخصات تکمیلی </span>
          <div fxLayout="column" fxLayoutAlign="space-around center">
            <form
              fxLayout="row wrap"
              fxLayoutAlign="space-around center"
              [formGroup]="personalUserForm"
            >
              <mat-form-field appearance="outline">
                <mat-label> نام کامل </mat-label>
                <input
                  formControlName="fullName"
                  [value]="userObject.fullName"
                  type="text"
                  matInput
                />
                <jam-icon name="user" matSuffix></jam-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> کد ملی </mat-label>
                <input
                  formControlName="nationalCode"
                  [value]="
                    userObject.nationalCode || 'وارد نشده' | digitsEnToFa
                  "
                  type="text"
                  matInput
                />
                <jam-icon name="fingerprint" matSuffix></jam-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> تاریخ تولد </mat-label>
                <input
                  [matDatepicker]="datePicker"
                  [value]="userObject.birthDate || 'وارد نشده' | digitsEnToFa"
                  formControlName="birthDate"
                  type="string"
                  matInput
                />
                <mat-datepicker
                  [(ngModel)]="userObject.birthDate"
                  #datePicker
                ></mat-datepicker>
                <button (click)="datePicker.open()" mat-icon-button matSuffix>
                  <jam-icon name="calendar-alt"></jam-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> ایمیل </mat-label>
                <input
                  formControlName="email"
                  [value]="userObject.email || 'وارد نشده'"
                  type="text"
                  matInput
                />
                <jam-icon name="envelope" matSuffix></jam-icon>
              </mat-form-field>
            </form>
            <button
              [disabled]="!personalUserForm.dirty"
              (click)="updateUserPersonalDataRequest()"
              mat-button
              color="primary"
            >
              <span>بروز رسانی <jam-icon name="save-f"></jam-icon></span>
            </button>
          </div>

          <mat-divider></mat-divider>
        </div>
      </div>

      <mat-divider></mat-divider>

      <div class="tab-gp" [class.disabled]="!!userObject.googleId">
        <div class="group user-sever-info">
          <span class="group-label">
            رمز عبور
            <small class="tab-description">
              در صورتی که توسط گوگل ثبت نام و از سایت استفاده میکنید نیازی به
              تغییر این گزینه ندارید.
            </small>
          </span>

          <div fxLayout="column" fxLayoutAlign="space-around center">
            <form
              [formGroup]="changePasswordFormGroup"
              fxLayout="row wrap"
              fxLayoutAlign="space-around center"
            >
              <mat-form-field appearance="outline">
                <mat-label> رمز عبور فعلی شما </mat-label>
                <input
                  formControlName="currentPassword"
                  type="password"
                  matInput
                />
                <jam-icon name="key" matSuffix></jam-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> رمز عبور جدید </mat-label>
                <input formControlName="pass" type="password" matInput />
                <jam-icon name="key" matSuffix></jam-icon>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label> تکرار رمز عبور جدید </mat-label>
                <input formControlName="confirmPass" type="password" matInput />
                <jam-icon name="key" matSuffix></jam-icon>
              </mat-form-field>
            </form>

            <button
              [disabled]="!changePasswordFormGroup.valid"
              (click)="changeUserPassword()"
              mat-button
              color="primary"
            >
              ذخیره تغییرات
              <jam-icon name="save-f"></jam-icon>
            </button>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- User corporation setting -->
    <!-- <mat-tab class="user-corporation-tab" label="همکاری در فروش">
      <div class="tab-gp">
        <jam-icon name="task-list" class="tab-hero" [size]="50"></jam-icon>

        <div class="tab-title">
          <h2>تنظیمات سیستم همکاری در فروش</h2>
          <small class="tab-description">
            تنظیمات مربوط به همکاری با زیراکسی.
          </small>
        </div>

        <br />
        <div class="group user-info">
          <span class="group-label">
            نوع دریافت سود
            <small class="tab-description">
              . دشما میتوانید سود دریافتی خود را با خریدار به صورت تخفیف تقسیم
              کنید یا همه آن را برای خود بردارید. این مربوط به استراتژی شما است.
              در خرید شما به مقدار ۱۰ درصد کل قیمت فروش سود دریافت خواهید کرد .
            </small>
          </span>
          <div
            style="overflow: hidden"
            fxLayout="row wrap"
            fxLayoutAlign="space-around center"
          >
            <span>{{ slider.value }}%</span>
            <mat-slider
              #slider
              value="10"
              style="width: 80%"
              color="primary"
              min="1"
              max="10"
              invert
            >
            </mat-slider>

            <button mat-button color="primary">
              ذخیره <jam-icon name="save"></jam-icon>
            </button>
          </div>

          <mat-divider></mat-divider>
        </div>
      </div>
    </mat-tab>

    <mat-tab class="user-corporation-tab" label="اطلاع رسانی">
      <div class="tab-gp">
        <jam-icon name="bell" class="tab-hero" [size]="50"></jam-icon>

        <div class="tab-title">
          <h2>تنظیمات قسمت اطلاع رسان</h2>
          <small class="tab-description">
            نحوه دریافت اطلاع رسان‌ها و دیگر موارد ... </small
          ><br />
        </div>

        <br />
      </div>
    </mat-tab> -->
  </mat-tab-group>
</div>
